//import styles
import Icon from "../base-icon/icon";
import "./base-tabs.scss";

function BaseTabs({ handleTabChange, list, style }) {
    return (
        <ul className="location-information-menu" style={style}>
            {list?.map(tab => {
                return (
                    <li
                        className={`location-information-menu__item
                            ${tab.activeTab ? "active-menu" : ""} 
                            ${tab.disable ? "disable" : ""} 
                            ${tab?.status === "inactive" ? "inactive-menu" : ""}`}
                        key={Math.random()}
                        onClick={tab.disable || tab?.status === "inactive" ? null : () => handleTabChange(tab.type, tab?.to)}
                    >
                        <Icon name={tab?.icon} style={{ cursor: "pointer", fill: tab.activeTab ? "var(--primary-color)" : "none" }} width="1rem" />
                        <span className="location-information-menu_title">{tab.title}</span>
                    </li>
                );
            })}
        </ul>
    );
}

export default BaseTabs;
